import { useDispatch, useSelector } from 'react-redux';
import SideBarMenu from './sidebarMenu';
import { POST_DETAILS } from '../constants';
import {
  setGeneralInfo,
  setRightMenuOpen
} from '../../../redux/slices/communication';

export default function SecondSideBarMenu() {
  const {
    ui: { rightMenuOpen, generalInfo },
    data: { activeConversation }
  } = useSelector((state) => state.communication);
  const dispatch = useDispatch();
  const buttons = [
    {
      icon: 'fa-duotone fa-info-circle',
      text: 'lomavis_communication.secondMenu.post_information',
      onClick: () => {
        if (generalInfo) return dispatch(setGeneralInfo(false));
        dispatch(setGeneralInfo(true));
      },
      name: 'general_info',
      active: true,
      currentlyActive: generalInfo,
      top: true
    },
    {
      icon: 'fa-duotone fa-paste',
      text: 'lomavis_communication.secondMenu.post_information',
      onClick: () => {
        if (rightMenuOpen === POST_DETAILS)
          return dispatch(setRightMenuOpen(null));
        dispatch(setRightMenuOpen(POST_DETAILS));
      },
      name: POST_DETAILS,
      active: activeConversation?.type === 'comment',
      top: true
    }
    // {
    //   icon: 'fa-duotone fa-tags',
    //   text: 'lomavis_communication.secondMenu.post_tags',
    //   onClick: () => {}
    // },
    // {
    //   icon: 'fa-duotone fa-user',
    //   text: 'lomavis_communication.secondMenu.assigned_user',
    //   onClick: () => {}
    // }
  ];
  if (!activeConversation) return null;
  // if (activeConversation.type !== 'comment') return null;
  return <SideBarMenu buttons={buttons} activeButton={rightMenuOpen} showSeperator={false} />;
}
